import { useLingui } from '@lingui/react/macro'
import { Button } from 'designSystem/components/Button'
import { ChartTooltip } from 'features/timeSeries/components/ChartTooltip'
import {
  TagBrowserList,
  TagListCoverage,
} from 'features/timeSeries/components/panes/TagBrowserList'
import { TagSearchDialog } from 'features/timeSeries/components/panes/TagSearchDialog'
import { useScatterplotContext } from 'features/timeSeries/ScatterplotContext'
import { WorkbenchPane } from 'features/workbench/WorkbenchPane'
import { Info, Maximize2 } from 'lucide-react'
import React, { useState } from 'react'

interface TagBrowserPaneProps {
  open?: boolean
  onOpenChange?: (open: boolean) => void
  coverage?: TagListCoverage
}

export const TagBrowserPane: React.FC<TagBrowserPaneProps> = ({
  open,
  onOpenChange,
  coverage,
}) => {
  const { t } = useLingui()

  const { sensorEntries } = useScatterplotContext()
  const [showDetails, setShowDetails] = useState(false)
  const [searchDialogOpen, setSearchDialogOpen] = useState(false)

  return (
    <WorkbenchPane
      title={t`Tags`}
      count={sensorEntries.length}
      grow
      open={open}
      onOpenChange={onOpenChange}
      actions={
        <>
          <ChartTooltip
            label={showDetails ? t`Hide descriptions` : t`Show descriptions`}
            side='bottom'>
            <Button
              variant='ghostMuted'
              size='icon-xs'
              pressed='accent'
              aria-pressed={showDetails}
              aria-label={
                showDetails ? t`Hide descriptions` : t`Show descriptions`
              }
              onClick={() => setShowDetails((current) => !current)}>
              <Info size={12} />
            </Button>
          </ChartTooltip>
          <ChartTooltip label={t`Expanded search`} side='bottom'>
            <Button
              variant='ghostMuted'
              size='icon-xs'
              aria-label={t`Expanded search`}
              onClick={() => setSearchDialogOpen(true)}>
              <Maximize2 size={12} />
            </Button>
          </ChartTooltip>
        </>
      }>
      <TagBrowserList showDetails={showDetails} coverage={coverage} />
      <TagSearchDialog
        open={searchDialogOpen}
        onOpenChange={setSearchDialogOpen}
        coverage={coverage}
      />
    </WorkbenchPane>
  )
}
